import { typeActionCreator, valueActionCreator } from '../action_creators';

export const IELTS_MODAL_SHOW = 'IELTS_MODAL_SHOW_ACTION';
export const IELTS_MODAL_HIDE = 'IELTS_MODAL_HIDE_ACTION';
